import { render, staticRenderFns } from "./PersonalizedQuestions.vue?vue&type=template&id=02027fcb&scoped=true"
import script from "./PersonalizedQuestions.vue?vue&type=script&lang=js"
export * from "./PersonalizedQuestions.vue?vue&type=script&lang=js"
import style0 from "./PersonalizedQuestions.vue?vue&type=style&index=0&id=02027fcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02027fcb",
  null
  
)

export default component.exports